import StickyNoteWidgetContainer from "../categories/stickyNote/StickyNoteWidgetContainer";
import WidgetUtils from "../../../utils/WidgetUtils";
import DirectValueWidgetContainer from "../categories/directValue/DirectValueWidgetContainer";
import IFrameWidget from './../categories/iFrame/IFrameWidget';
import ControllerWidgetContainer from "../categories/controller/ControllerWidgetContainer";
import ChartWidgetContainer from './../categories/graph/ChartWidgetContainer';
import TitleWidgetContainer from "../categories/title/TitleWidgetContainer";


let WidgetComponentsByType = {
    for: function (type) {
        switch (type) {
            case WidgetUtils.WidgetType.DIRECT_VALUE:
                return DirectValueWidgetContainer;
            case WidgetUtils.WidgetType.STICKY_NOTE:
                return StickyNoteWidgetContainer;
            case WidgetUtils.WidgetType.CONTROLLER:
                return ControllerWidgetContainer;
            case WidgetUtils.WidgetType.IFRAME:
                return IFrameWidget;
            case WidgetUtils.WidgetType.COMPLEX_CHART:
                return ChartWidgetContainer;
            case WidgetUtils.WidgetType.TITLE:
                return TitleWidgetContainer;
            default:
                throw new Error("Missing component for widget type: " + type);
        }
    }
};

export default WidgetComponentsByType;